import type { FC, MouseEvent as ReactMouseEvent, ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'

import DialogNames from '~/constants/DialogNames'
import useDialog from '~/utils/useDialog'

interface AgentLinkProps {
  [key: string]: any
  children?: ReactNode
  className?: string
  href: string
  onClick?: (e: ReactMouseEvent) => void
}

/**
 * Enhanced Link component for agent chat that handles special navigation cases.
 * Scheduler appointments: Opens dialog when already on scheduler page.
 * Future patterns can be added as else-if blocks in handleClick.
 */
export const AgentLink: FC<AgentLinkProps> = ({
  className,
  children,
  href,
  onClick,
  ...props
}) => {
  const location = useLocation()
  const [openAppointmentDialog] = useDialog(DialogNames.EVENT)

  const schedulerAppointmentMatch = href.match(
    /^\/scheduler\/schedule\/([\w-]+)/,
  )

  const handleClick = (e: ReactMouseEvent) => {
    onClick?.(e)
    if (schedulerAppointmentMatch) {
      const appointmentId = schedulerAppointmentMatch[1]
      const isOnSchedulerPage = location.pathname.startsWith('/scheduler')
      const isOnSameAppointment = location.pathname.includes(
        `/schedule/${appointmentId}`,
      )

      if (isOnSchedulerPage) {
        if (isOnSameAppointment) {
          e.preventDefault()
        }
        openAppointmentDialog({
          appointmentId,
          isAppointmentType: true,
        })
      }
    }
  }

  return (
    <Link className={className} to={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}
